import { createFileRoute } from "@tanstack/react-router";
import Cars from "@/pages/Cars";
import { buildNoindexHead, noindexLoader, type NoindexSEO } from "@/lib/noindex-route-seo";

const TITLES: NoindexSEO = {
  "es": "Alquiler de coches",
  "pt-BR": "Aluguel de carros",
  "en": "Car rental",
  "en-EU": "Car rental",
};

export const Route = createFileRoute("/coches")({
  loader: noindexLoader,
  head: ({ loaderData }) => buildNoindexHead(TITLES, "/coches", loaderData),
  component: Cars,
});
